const placeItems = {
    name: "place-items",
    path: "/place-items",
    title: "place-items",
    description: "Utilities for setting both align-items and justify-items at once in grid layouts.",
    value: {
        "place-items": {
            "place-items-start": "start",
            "place-items-end": "end",
            "place-items-end-safe": "safe end",
            "place-items-center": "center",
            "place-items-center-safe": "safe center",
            "place-items-stretch": "stretch",
            "place-item-baseline": "baseline",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-rows-3 grid-columns-3 h-64 place-items-center gap-4">
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">01</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">02</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">03</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">04</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">05</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">06</div>
</div>

<div class="grid grid-rows-3 grid-columns-3 h-64 place-items-end gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">01</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">02</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">03</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">04</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">05</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">06</div>
</div>

<div class="grid grid-rows-3 grid-columns-3 h-64 place-items-start gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">01</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">02</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">03</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">04</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">05</div>
  <div class="bg-color-pink-500 text-white p-2 flex justify-center items-center rounded-lg">06</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">place-items-*</code> utilities to set both <b>align-items</b> and <b>justify-items</b> at once in grid layouts.
            </p>
            <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">place-items-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-center font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-items-end</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-end font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-items-start</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-start font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
    ]
}
export default placeItems;

<div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">place-items-center</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-center font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-items-end</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-end font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">place-items-start</small>
                    <div class="relative">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-64 gap-4 place-items-start font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">01</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">02</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">03</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">04</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">05</div>
                            <div class="bg-color-pink-500 flex justify-center items-center rounded-lg w-24 h-24">06</div>
                        </div>
                    </div>
                </div>
            </div>